import type { Dayjs } from "dayjs";
import { dayjs } from "./dayjs";

const daysBetween = (date1: Dayjs, date2: Dayjs) => {
  if (date2) {
    let current = dayjs(date1);
    const days = [];
    const end = dayjs(date2);

    while (current.isSame(end) || current.isBefore(end)) {
      days.push(current.format("YYYY-MM-DD"));
      current = current.add(1, "day");
    }

    return days;
  } else {
    return [dayjs(date1).format("YYYY-MM-DD")];
  }
};

const formatDuration = (durationInMilliseconds: number) => {
  const totalSeconds = Math.floor(durationInMilliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (totalSeconds % 60).toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

const parseTime = (date: string, time: string) =>
  dayjs(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss");

const toUtcDateTime = (date: Dayjs, time: Dayjs, timezone: string) => {
  return dayjs
    .tz(
      `${date.format("YYYY-MM-DD")}T${time.format("HH:mm:ss")}`,
      timezone,
    )
    .utc();
};

const toZonedDateTime = (date: Dayjs, time: Dayjs, timezone: string) =>
  dayjs.tz(
    `${date.format("YYYY-MM-DD")} ${time.format("HH:mm:ss")}`,
    "YYYY-MM-DD HH:mm:ss",
    timezone,
  );

export {
  daysBetween,
  formatDuration,
  parseTime,
  toUtcDateTime,
  toZonedDateTime,
};
